import { Injectable, OnDestroy } from '@angular/core';
import { GlassHouseBrandGroupIndexCardStackContentViewModel } from '../../index-cards-3x5/glass-house-brand-group-index-card-stack-content/glass-house-brand-group-index-card-stack-content-view-model';

@Injectable()
export class GlassHouseBrandGroupThreeByFourStackContentViewModel
  extends GlassHouseBrandGroupIndexCardStackContentViewModel
  implements OnDestroy
{
  protected N_ITEMS_ON_CARD = 2;

  // This is only here because prettier can't handle the class declaration by making it multiple lines without
  // having the implements clause added too.
  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
